var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLicensesAdmin(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.9997 18.335C21.3189 18.335 18.335 21.3189 18.335 24.9997C18.335 27.0362 19.2484 28.8594 20.688 30.0819V36.811L24.7056 34.8022L28.7233 36.811V30.588C28.7233 30.5682 28.7229 30.5484 28.7222 30.5287C30.4972 29.3313 31.6644 27.3018 31.6644 24.9997C31.6644 21.3189 28.6805 18.335 24.9997 18.335ZM21.6644 24.9997C21.6644 23.1576 23.1576 21.6644 24.9997 21.6644C26.8417 21.6644 28.335 23.1576 28.335 24.9997C28.335 26.8417 26.8417 28.335 24.9997 28.335C23.1576 28.335 21.6644 26.8417 21.6644 24.9997Z",
    fill: "#0067DF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.21777 1.86475H35.7825V19.9H32.4531V5.19416H7.54719V31.2765H17.3209V34.6059H4.21777V1.86475Z",
    fill: "#0067DF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6885 9.80591H29.312V13.1353H10.6885V9.80591Z",
    fill: "#0067DF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6649 15.9824H10.6885V19.3118H16.6649V15.9824Z",
    fill: "#0067DF"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLicensesAdmin);
export default __webpack_public_path__ + "static/media/licensesAdmin.e808436dcebd41e81b4bf27cbe5b6a01.svg";
export { ForwardRef as ReactComponent };